import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  obtenerAsignacionesPorClase,
  getGrupoMatricula,
  obtenerEntregasPorAsignacion,
} from "./constants";
import { useData } from "./DataContext";
import NavigationIcon from "../Others/NavigationIcon";
import "./HomeworkModule.css";

const CalificacionTeacher = () => {
  const { dataClase } = useData();
  const [tareas, setTareas] = useState([]);
  const [entregasPorAsignacion, setEntregasPorAsignacion] = useState({});
  const [alumnos, setAlumnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState("");
  const [error, setError] = useState("");

  const fetchCalificacionesSecuencial = async (asignaciones) => {
    const results = [];

    for (let index = 0; index < asignaciones.length; index += 1) {
      const asignacion = asignaciones[index];
      try {
const response = await axios.get(
  obtenerEntregasPorAsignacion(asignacion.id_asignacion)
);
        results.push({
          id_asignacion: asignacion.id_asignacion,
          deliveries: Array.isArray(response.data.data)
            ? response.data.data
            : [],
        });
      } catch (requestError) {
        console.error(
          "Error al obtener calificaciones para la asignación:",
          asignacion.id_asignacion,
          requestError
        );
        throw requestError;
      }
      setProgress(
        "Obteniendo calificaciones: " +
          (index + 1) +
          " de " +
          asignaciones.length
      );
    }

    return results;
  };

  useEffect(() => {
    if (!dataClase?.matricula_clase) return;
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError("");

        const responseAlumnos = await axios.post(getGrupoMatricula, {
          matricula_clase: dataClase.matricula_clase,
        });
        const alumnosData =
          responseAlumnos.data && Array.isArray(responseAlumnos.data.data)
            ? responseAlumnos.data.data.map((alumno) => ({
                matricula: alumno.id_alumno,
                nombre: alumno.nombre_alumno + " " + alumno.apellido_alumno,
              }))
            : [];

        const urlAsignaciones = obtenerAsignacionesPorClase(
          dataClase.matricula_clase
        );
        const responseAsignaciones = await axios.get(urlAsignaciones);
        const asignaciones = Array.isArray(responseAsignaciones.data)
          ? responseAsignaciones.data
          : responseAsignaciones.data.asignaciones || [];

        const results = await fetchCalificacionesSecuencial(asignaciones);
        const entregas = {};
        results.forEach((result) => {
          entregas[result.id_asignacion] = result.deliveries;
        });

        if (isMounted) {
          setAlumnos(alumnosData);
          setTareas(asignaciones);
          setEntregasPorAsignacion(entregas);
        }
      } catch (requestError) {
        console.error("Error al cargar las calificaciones:", requestError);
        if (isMounted) {
          setError("No fue posible cargar las calificaciones del grupo.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
          setProgress("");
        }
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [dataClase?.matricula_clase]);
const getDeliveryForStudent = (alumnoMatricula, idAsignacion) => {
  const deliveries = Array.isArray(entregasPorAsignacion[idAsignacion])
    ? entregasPorAsignacion[idAsignacion]
    : [];

  return (
    deliveries.find(
      (item) => String(item.id_alumno) === String(alumnoMatricula)
    ) || null
  );
};
const getGradeForStudent = (alumnoMatricula, idAsignacion) => {
  const entrega = getDeliveryForStudent(alumnoMatricula, idAsignacion);
  return entrega?.calificacion ?? null;
};

  const computeStudentAverage = (alumnoMatricula) => {
    let sum = 0;
    let count = 0;

    tareas.forEach((asignacion) => {
      const grade = getGradeForStudent(
        alumnoMatricula,
        asignacion.id_asignacion
      );
      if (grade !== null && grade !== undefined && grade !== "") {
        const numericGrade = parseFloat(grade);
        if (!Number.isNaN(numericGrade)) {
          sum += numericGrade;
          count += 1;
        }
      }
    });

    return count === 0 ? "-" : (sum / count).toFixed(2);
  };

  return (
    <section className="homework-section" aria-labelledby="grades-summary-title">
      <header className="homework-section-header">
        <div>
          <h2 id="grades-summary-title">Calificaciones por alumno</h2>
          <p>Consulta el desempeño por actividad y el promedio del grupo.</p>
        </div>
        <span className="homework-badge">
          {alumnos.length} {alumnos.length === 1 ? "alumno" : "alumnos"}
        </span>
      </header>

      {error && (
        <div className="homework-status is-error" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="homework-loading" aria-live="polite">
          <span className="homework-spinner" />
          <strong>Cargando calificaciones</strong>
          <p>{progress || "Estamos consultando el avance del grupo."}</p>
        </div>
      ) : alumnos.length === 0 || tareas.length === 0 ? (
        <div className="homework-empty">
          <span className="homework-empty-icon">
            <NavigationIcon name="diagnostic" size={28} />
          </span>
          <strong>No hay calificaciones para mostrar</strong>
          <p>
            Se necesita al menos una tarea y un alumno registrado en la clase.
          </p>
        </div>
      ) : (
        <div className="homework-table-wrap">
          <table className="homework-table">
            <thead>
              <tr>
                <th>Alumno</th>
                {tareas.map((asignacion) => (
                  <th key={asignacion.id_asignacion}>{asignacion.nombre}</th>
                ))}
                <th>Promedio</th>
              </tr>
            </thead>
            <tbody>
              {alumnos.map((alumno) => (
                <tr key={alumno.matricula}>
                  <td>{alumno.nombre}</td>
                  {tareas.map((asignacion) => {
  const entrega = getDeliveryForStudent(
    alumno.matricula,
    asignacion.id_asignacion
  );

  const grade = entrega?.calificacion;

  return (
    <td key={asignacion.id_asignacion}>
      {!entrega ? (
        <span className="homework-badge is-warning">
          No entregado
        </span>
      ) : grade !== null &&
        grade !== undefined &&
        grade !== "" ? (
        <span className="homework-grade">{grade}</span>
      ) : (
        <span className="homework-badge is-warning">
          Pendiente de calificación
        </span>
      )}
    </td>
  );
})}
                  <td>
                    <span className="homework-grade">
                      {computeStudentAverage(alumno.matricula)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default CalificacionTeacher;
